import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import * as RouterActions from './router.actions';
import { GoPayload } from './router.actions';
import { AzureMonitoringService } from '../../services/AzureMonitoringService';

@Injectable({ providedIn: 'root' })
export class RouterEffects {
  navigate$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(RouterActions.goAction),
        tap(payload => {
          let { path } = payload as GoPayload;
          const { query: queryParams, extras } = payload as GoPayload;
          if (typeof path === 'string') {
            path = [path];
          }
          this.azureMonitoringService.logEvent(`GoAction: Will navigate to ${path.join(' & ')}`);
          this.router.navigate(path, { queryParams, ...extras });
        })
      ),
    { dispatch: false }
  );
  navigateBack$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(RouterActions.backAction),
        tap(() => this.location.back())
      ),
    { dispatch: false }
  );
  navigateForward$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(RouterActions.forwardAction),
        tap(() => this.location.forward())
      ),
    { dispatch: false }
  );

  constructor(private actions$: Actions, private router: Router, private location: Location, private azureMonitoringService: AzureMonitoringService) {}
}
